import * as React from 'react';

function SvgAccountIcon(props) {
  return (
    <svg viewBox="0 0 13 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.826 8.364c2.353 0 4.268-1.876 4.268-4.182C11.094 1.876 9.179 0 6.826 0 4.474 0 2.56 1.876 2.56 4.182c0 2.306 1.915 4.182 4.267 4.182zM5.19 9.13C2.218 9.13 0 11.134 0 14.044v.313c0 1.521 2.378 1.521 5.387 1.521h3.198c2.891 0 5.388 0 5.388-1.521v-.313c0-2.91-2.22-4.914-5.19-4.914H5.19z" />
    </svg>
  );
}

export default SvgAccountIcon;
